export const REPHERRAL_CREATE = '/create';
export const REPHERRAL_DETAIL = '/r/:id';
export const COMPANY_REPHERRALS = '/to/:company';
export const REGISTER = '/register';
export const LOGIN = '/login';
export const HOME = '/';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/forgot-password';
export const FAQ = '/faq';
